import { Record, type RecordOf } from 'immutable';

import type { TaxFormType } from '../categories/categoriesTypes';
import type { QcsSyncResourceStore } from '../core/resourceStoreTypes';

export type { TaxFormType };
export type TaxFormRecord = RecordOf<TaxFormType>;

export const mkTaxForm = Record<TaxFormType>({
  id: undefined,
  country: undefined,
  txfId: undefined,
  name: undefined,
  description: undefined,
  displayOrder: undefined,
  primary: undefined,
});

export const TAX_FORMS_REDUCER_KEY = 'taxFormsStore' as const;

declare module 'app-components/utils/redux-store/rootState' {
  export default interface RootState {
    [TAX_FORMS_REDUCER_KEY]: QcsSyncResourceStore<TaxFormType>;
  }
}
